import React, { useState } from 'react';
import { Badge } from '../Ui';
import { useDebouncedSearch } from '../../hooks/useLiveData';

export default function EmrPatientBar({
  patient,
  allergies,
  onSearch,
  searchResults = [],
  onPickPatient,
  readOnly = false,
}) {
  const [query, setQuery] = useState('');
  const debouncedSearch = useDebouncedSearch(onSearch || (() => {}), 350);
  const hasAllergy = allergies && allergies.trim().length > 0;

  return (
    <div className={`emr-patient-bar ${hasAllergy ? 'has-allergy' : ''}`}>
      <div className="emr-patient-main">
        <div className="emr-patient-avatar">{(patient.name || '?')[0]}</div>
        <div>
          <h2 className="emr-patient-name">{patient.name || 'Select patient'}</h2>
          <div className="emr-patient-meta">
            {patient.patientId && <span>ID: {patient.patientId}</span>}
            {patient.age && <span>{patient.age} yrs</span>}
            {patient.gender && <span>{patient.gender}</span>}
            {patient.phone && <span>{patient.phone}</span>}
            <Badge tone="info">{patient.visitType || 'OPD'}</Badge>
          </div>
        </div>
      </div>
      {hasAllergy && (
        <div className="emr-allergy-alert">
          <strong>⚠ Allergies:</strong> {allergies}
        </div>
      )}
      {onSearch && !readOnly && (
        <div className="emr-patient-search">
          <input
            className="input"
            placeholder="Search patient by name, UHID or phone…"
            value={query}
            onChange={(e) => {
              const v = e.target.value;
              setQuery(v);
              debouncedSearch(v);
            }}
          />
          {searchResults.length > 1 && (
            <div className="emr-search-results">
              {searchResults.map((p) => (
                <button
                  key={p.patientId}
                  type="button"
                  className="emr-search-result-row"
                  onClick={() => {
                    onPickPatient?.(p);
                    setQuery('');
                  }}
                >
                  <strong>{p.name}</strong>
                  <span className="hint">{p.patientId}{p.phone ? ` · ${p.phone}` : ''}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
